<div id="topMenuWrap" class="box">
    <div class="menu-content-wrap">
        <!-- <img src="assets/img/admiral-log.svg" class="logo" alt="Logo"> -->
        <ng-container *ngIf="enivroment.viewConfiguration === siteViewConfigurationEnum.NIGERIA; else admiral">
            <a class="link" [routerLink]="['/betting', 'prematch']">
                <img class="logo" src="assets/img/wgb-logo-color.png" alt="Logo">
            </a>
        </ng-container>
        <ng-template #admiral>
            <a class="link" [routerLink]="['/betting', 'prematch']">
                <img class="logo" src="assets/img/admiral-log.svg" alt="Logo">
            </a>
        </ng-template>
        <div class="menu-wrap">
            <a class="link" [routerLink]="['/betting', 'prematch']">PREMATCH</a>
            <a class="link" [routerLink]="['/betting', 'live']">LIVE</a>
            <!-- <a class="link" [routerLink]="['/betting', 'live']">BECOME AN AGENT</a> -->
        </div>
    </div>
    <div class="log-content-wrap">
        <div class="log-content">
            <!-- <select class="select-wrap" (change)="selectLanguage($event.target.value)">
                <option value="en" [selected]="language == 'en'">English</option>
                <option value="en-NG" [selected]="language == 'en-NG'">Nigerian</option>
            </select> -->

            <div class="input-wrap" *ngIf="!isUserLoggedIn">
                <input type="text" class="form-control" (keypress)="pressedEnter($event.keyCode)" [(ngModel)]="loginParam.username" placeholder="Username">
                <div class="password-wrap">
                    <input type="password" class="form-control" (keypress)="pressedEnter($event.keyCode)" [(ngModel)]="loginParam.password" placeholder="Password" [type]="showHidePassword ? 'text': 'password'">
                    <mat-icon matSuffix class="mat-icon notranslate pointer material-icons mat-icon-no-color" (click)="showHidePassword = !showHidePassword" data-mat-icon-type="font">{{showHidePassword ? 'visibility' : 'visibility_off'}} </mat-icon>
                </div>
            </div>
            <button (click)="login()" *ngIf="!isUserLoggedIn">LOGIN</button>
            <div class="logged-buttons" *ngIf="isUserLoggedIn">
                <div class="flex">
                    <button (click)="addToBalance()" *ngIf="loggedUser.affiliateRole == affiliateRoleEnum.operatorTrader && viewConfigurations.isMoneyTransferEnabled">Add To Balance</button>
                    <div class="balance flex">
                        <label>My Balance:</label>
                        <label class="value">{{loggedUser?.currentBalance | number:'1.2-2'}}</label>
                    </div>
                    <button class="m-r" *ngIf="!isAccount" (click)="ticketManager()"><i class="icon icon-users"></i> ACCOUNT</button>
                    <button class="btn outline-danger" (click)="logout()"><i class="icon icon-power-switch"></i> LOGOUT</button>
                </div>
                <div>
                    <ng-container *ngIf="loggedUser?.affiliateRole === affiliateRoleEnum.agent || loggedUser?.affiliateRole === affiliateRoleEnum.cashier; else fullName">
                       {{loggedUser?.username}}
                    </ng-container>
                    <ng-template #fullName>{{loggedUser?.firstName}} {{loggedUser?.lastName}}</ng-template>
                </div>
            </div>
            <!-- <button class="register" (click)="register()">Register</button> -->
        </div>
        <!-- <div class="link" *ngIf="!isUserLoggedIn" (click)="resetPass()">Forgot Password?</div> -->
        <span id="errorMessage" class="error-message" *ngIf="showError">{{errorText}} &nbsp;</span>
    </div>
    <!-- <div *ngIf="loggedUser">
    <button (click)="logOut()">Logout</button>
    <button (click)="account()">Account</button>
  </div> -->
</div>
